import React from "react";
import { FormattedMessage } from "react-intl";
import {
  Box,
  Button,
  Text,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

const ConfirmDeletePayoutModal = ({ isOpen, onClose, onConfirm, isLoading }) => {
  const disabled = isLoading;
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent pb="8" px="8">
        <ModalHeader />
        <ModalCloseButton />
        <ModalBody p="10">
          <Text fontSize="lg" fontWeight="500" textAlign="center">
            <FormattedMessage defaultMessage="Cancel Transaction" description="Section title" />
          </Text>
          <Box mt="5">
            <FormattedMessage
              defaultMessage="Are you sure you want to cancel this transaction?"
              description="User message"
            />
          </Box>
        </ModalBody>
        <HStack justifyContent="end" spacing="2">
          <Button colorScheme="gray" onClick={onClose} isDisabled={disabled}>
            <FormattedMessage defaultMessage="Cancel" description="Button label" />
          </Button>
          <Button onClick={onConfirm} isDisabled={disabled}>
            <FormattedMessage defaultMessage="Confirm" description="Button label" />
          </Button>
        </HStack>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmDeletePayoutModal;
